import { useUserId } from '../authentication/useUserId';
import { useUserActions } from '../../resource/resources/persistables/user/userResource';

export const useAdminRights = (projectId?: string) => {
    const userId = useUserId('');

    const userActions = useUserActions();
    const userSystemRights = userActions.useGetUserEffectiveRightsOfUser(userId, projectId);

    const isAdminOrServerAdmin = Boolean(
        userSystemRights.data && (userSystemRights.data.isAdmin || userSystemRights.data.isServerAdmin),
    );

    const isProcessAdmin = Boolean(!userSystemRights.data || userSystemRights.data.isProcessAdmin);
    const isManager = Boolean(!userSystemRights.data || userSystemRights.data.isManager);
    const isReader = Boolean(!userSystemRights.data || userSystemRights.data.isReader);

    return {
        isAdminOrServerAdmin,
        isProcessAdmin,
        isManager,
        isReader,
    };
};
